import {
  Stepper,
  Form,
  Radio,
  Email,
  PhoneNumber,
  NameTextField,
  Button,
  CompanyCity,
  CompanySIRET,
  Hidden,
  Select,
  Checkbox,
  
} from "@lmt/taskforce-react-form";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import radioClasses from "@mui/material/Radio/radioClasses";
import CircularProgress from "@mui/material/CircularProgress";
import FormLabel from "@mui/material/FormLabel";
import { styled } from "@mui/material/styles";

const MarginTopInputs = -1.2;

const Text = styled("div")(({ theme }) => ({
  fontFamily: "Helvetica,Arial,sans-serif",
  fontSize: "14 px",
  
}));


const theme = createTheme({
  palette: {
      primary: {
          main: "#000000",
      },
  },
  components: {
      MuiButton: {
          defaultProps: {
              size: "large",
          },
          styleOverrides: {
              root: {
                  borderRadius: 30,
                  backgroundColor: "#ffffff",
                  color: "#000000",
                  border: "solid 3px #000000",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  minWidth: "200px",
                  maxWidth: "220px",
                  "&:hover": {
                      backgroundColor: "#000000",
                      color: "#ffffff",
                  },
              },
          },
      },
      MuiButtonGroup: {
          defaultProps: {
              size: "small",
          },
      },
      MuiCheckbox: {
          defaultProps: {
              size: "small",
          },
          styleOverrides: {
            root: {
              color: "#000000",
              '& .MuiFormControlLabel-label': {
                color: '#000000',
              },
              [`&.${radioClasses.checked}`]: {
                color: "#000000",
              },
              "& .css-1o543t0-MuiFormLabel-root": {
                color: "#000000",
              },
            },
          },
      },
      MuiFormControl: {
          defaultProps: {
              margin: "dense",
              size: "small",
          },
          styleOverrides: {
              root: {
                  
                  "&:hover": {
                      border: 0,
                  },
                  "& .MuiBox-root .MuiFormLabel-root": {
                      color: "#000000",
                  },
                  "& .MuiBox-root .Mui-error": {
                      color: "#d32f2f",
                  },
              },
          },
      },
      MuiFormHelperText: {
          defaultProps: {
              margin: "dense",
          },
      },
      MuiInputBase: {
          defaultProps: {
              margin: "dense",
          },
          styleOverrides: {
              root: {
                  borderRadius: "10px !important",
                  paddingLeft: "8px",
                  color: "#000000",
                  "&:before": {
                    borderBottom: "1px solid #000000 !important",
                  },
              },
          },
      },
      MuiInputLabel: {
          defaultProps: {
              margin: "dense",
          },
          styleOverrides: {
              root: {
                  paddingLeft: "10px",
                  color: "#000000",
                
                 
              },
          },
      },
      MuiFormControlLabel: {
          defaultProps: {},
          styleOverrides: {
              root: {
                  "& .MuiTypography-root": {
                      color: "#000000",
                  },
              },
          },
      },

  MuiAutocomplete: {
    styleOverrides: {
      root: {
        "& .MuiFilledInput-root.MuiInputBase-sizeSmall .MuiFilledInput-input":
          {
            paddingLeft: "10px",
          },
          
      },
    },
  },
  MuiRadio: {
    defaultProps: {
      size: "small",
    },
    styleOverrides: {
      root: {
        color: "#000000",
        [`&.${radioClasses.checked}`]: {
          color: "#000000",
        },
        
      },
    },
  },
  MuiTextField: {
    defaultProps: {
      margin: "dense",
      size: "large",
    },
    styleOverrides: {
        root: {
          color: "#000000",
        },
      },
  },
  MuiFilledInput: {
    styleOverrides: {
      root: {
        
        backgroundColor: "#FFFFFF",
        Color: "#000000",

        borderBottom: "0px",
        "&:hover": {
          backgroundColor: "#FFFFFF",
          borderBottom: "0px",
        },
        "&:before": {
          borderBottom: "0px",
        },
        "&:after": {
          borderBottom: "0px",
        },
        "&:hover:not(.Mui-disabled):before": {
          borderBottom: "0px",
        },
        "&.Mui-focused": {
          backgroundColor: "#FFFFFF",
          borderBottom: "0px",
        },
        "&.Mui-disabled": {
          backgroundColor: "#FFFFFF",
          borderBottom: "0px",
        },
      },
    },
  },
  MuifilledInput: {
    styleOverrides: {
      root: {
       
        backgroundColor: "#FFFFFF",
        Color: "#000000",
      },
      notchedOutline: {
        border: 0,
      },
    },
  },
  MuiSelect: {
    styleOverrides: {
      filled: {
        padding: "18px 12.5px",
      },
      
      root: {
       
      },
    },
  },
},
});


function App() {
  return (
      <ThemeProvider theme={theme}>
          <Stepper
              steps={[
                  <Form
                      onSubmit={({origin}) =>
                          (window.top.location.href = `https://www.vertical-mail.com/${origin}/good.php`)
                      }
                  >
                      <Box mt={MarginTopInputs} sx={{paddingLeft: "0"}}>
                          <Radio
                              inline
                              variant="outlined"
                              label="Civilité"
                              name="reference_civility"
                              required={true}
                              items={[
                                  {label: "Monsieur", value: 1},
                                  {label: "Madame", value: 2},
                                  
                              ]}
                          />
                      </Box>
                      <Box mt={MarginTopInputs}>
                        <NameTextField
                            label="Nom"
                            name="last_name"
                            required="Champ obligatoire"
                            validatorMessage="Nom incorrect"
                            variant="outlined"
                        />
                     </Box>
                     <Box mt={MarginTopInputs}>
                        <NameTextField
                            label="Prénom"
                            name="first_name"
                            required="Champ obligatoire"
                            validatorMessage="Prénom incorrect"
                            variant="outlined"
                        />
                    </Box>
                    
                    <Box mt={MarginTopInputs}>
                        <PhoneNumber
                            label="Téléphone"
                            name="phone_number_mobile"
                            required="Champ obligatoire"
                            validatorMessage="Téléphone incorrect"
                            variant="outlined"
                        />
                    </Box>
                    <Box mt={MarginTopInputs}>
                        <Email
                            label="E-mail"
                            name="email"
                            required="Champ obligatoire"
                            validatorMessage="Email incorrect"
                            variant="outlined"
                        />
                    </Box>
                     
                      
                      <Box>
                          <CompanyCity
                              rowSpacing={MarginTopInputs}
                              propsCompany={{
                                  label: "Société",
                                  name: "autocomplete_company",
                                  companyName: "company_name",
                                  sirenName: "siren",
                                  required: "Champ obligatoire",
                                  variant:"outlined",
                                  companyAddress: "address",
                                  companyZipcode: "company_zipcode",
                              }}
                              propsCity={{
                                  label: "Ville",
                                  name: "autocompletion_city",
                                  cityName: "city",
                                  postcodeName: "zipcode",
                                  cityInseeCodeName: "insee_code_city",
                                  required: "Champ obligatoire",
                                  variant:"outlined",
                              }}
                          />
                      </Box>

                      <Box mt={MarginTopInputs}>
                          <CompanySIRET
                              label="Établissement"
                              name="company_siret"
                              addressName="address"
                              postcodeName="zipcode"
                              codeNafName="company_naf_code"
                              cityInseeCodeName="insee_code"
                              required="Champ obligatoire"
                              variant="outlined"
                              dependOfCity="insee_code_city"
                          />
                      </Box>

                      
                      <Box mt={MarginTopInputs}>
                          <Select
                              label="Taille de la flotte"
                              variant="outlined"
                              name="company_legal_form"
                              required="Champ obligatoire"
                              items={[
                                {
                                    value: "10",
                                    label: "5 à 19 véhicules",
                                },
                                {
                                    value: "20",
                                    label: "20 à 39 véhicules",
                                },
                                {
                                    value: "40",
                                    label: "+ de 40 véhicules",
                                },
                            ]}
                          />
                      </Box>

                      <Box mt={MarginTopInputs}>
                          <Select
                              label="Délai de projet"
                              variant="outlined"
                              name="project_description"
                              required="Champ obligatoire"
                              items={[
                                {
                                    value: "J ai un projet immediat",
                                    label: "J'ai un projet immédiat",
                                },
                                {
                                    value: "J ai un projet a moins de 3 mois",
                                    label: "J'ai un projet a moins de 3 mois",
                                },
                                {
                                    value: "J ai un projet de 3 a 6 mois",
                                    label: "J'ai un projet de 3 a 6 mois",
                                },
                                {
                                    value: "J ai un projet a plus de 6 mois",
                                    label: "J'ai un projet a plus de 6 mois",
                                },
                                
                            ]}
                          />
                      </Box>


                      
                      <Hidden name="origin"/>
                      <Box sx={{display: "flex", justifyContent: "center",}} mt={2}>
                          <Button/>
                      </Box>

                      <Box sx={{ display: "flex", justifyContent: "center" }} mt={2}>
                        <Text>* Champs obligatoires</Text>
                      </Box>


                  </Form>,
              ]}
              result={
                  <Box
                      sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                          width: "100%",
                      }}
                  >
                      <CircularProgress/>
                  </Box>
              }
          />
      </ThemeProvider>
  );
}

export default App;
